import { render } from "./AgentSign.vue?vue&type=template&id=babd1c10&scoped=true"
import script from "./AgentSign.vue?vue&type=script&lang=js"
export * from "./AgentSign.vue?vue&type=script&lang=js"

import "./custom-agent-sign.scss?vue&type=style&index=0&id=babd1c10&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-babd1c10"]])

export default __exports__